// Copyright (C) 2022 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { Col, Row } from 'antd/lib/grid';
import Layout from 'antd/lib/layout';
import Button from 'antd/lib/button';
import './styles.scss';

const { Content } = Layout;

/**
 * Component for displaying message that email confirmation URL is incorrect
 */

export default function IncorrectEmailConfirmationPage(): JSX.Element {
    return (
        <Layout>
            <Content>
                <Row justify='center' align='middle' id='incorrect-email-confirmation-page-container'>
                    <Col>
                        <h1>
                            Срок действия этой ссылки подтверждения по электронной почте истек или она недействительна.
                        </h1>
                        <p>
                            Пожалуйста, отправьте новый запрос на подтверждение по электронной почте.
                        </p>
                        <Button className='cvat-go-to-login-button' type='link' href='/auth/login'>
                            Перейти на страницу входа
                        </Button>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}
